/**
 * SFrame181 — Notify government agencies with deadlines, proof tracking, and planner contacts.
 */

import { useParams, Navigate } from 'react-router-dom';
import SettlementStepPage from '../settlement/SettlementStepPage';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';

const step = SETTLEMENT_PHASE_CONFIGS.notify.steps.find((s) => s.id === 'not-1')!;

export default function SFrame181() {
  const { estateId } = useParams<{ estateId: string }>();

  // Guard: estateId is required for all save operations — redirect to estate
  // selector so the user re-enters via the proper route with an estateId.
  if (!estateId) return <Navigate to="/estate-selector" replace />;

  const overview = `/sframe-180/${estateId}`;

  return (
    <SettlementStepPage step={step} phase="notify" overviewRoute={overview} plannerFrameIds={['frame-146']} />
  );
}
